import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=0227c0b4&scoped=true&"
import script from "./UserCards.vue?vue&type=script&lang=js&"
export * from "./UserCards.vue?vue&type=script&lang=js&"
import style0 from "./UserCards.vue?vue&type=style&index=0&id=0227c0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227c0b4",
  null
  
)

export default component.exports